import React from 'react';
import ServiceDescriptionSection from '../../components/ServiceDescriptionSection';
import ServiceLegalRepresentationRationale from '../../components/ServiceLegalRepresentationRationale';
import ServiceContactUsSection from '../../components/ServiceContactUs';
import ServiceTypes from '../../components/ServiceTypes';
import ServiceInVictoria from '../../components/ServiceInVictoria';
import serviceTypesData from '../../data/serviceTypes.json';

const SexualOffences = () => {
  return (
    <div className='servicePage'>
      <div className='servicePageContent'>
        <div className="header">Sexual Offences</div>
        <div className="body">
          <ServiceInVictoria
            header="Sexual Offences in Victoria"
            content="Sexual offences are taken very seriously in Victoria, with strict laws in place to protect victims and hold offenders accountable. These crimes encompass a wide range of unlawful sexual behaviours, from indecent exposure to serious crimes like rape and sexual assault. Offenders can face severe penalties, including lengthy prison sentences, as well as lifelong consequences such as being placed on the sex offender register."
          />
          <ServiceTypes
            header="Types of Sexual Offences"
            preamble="Sexual offences in Victoria can be broadly categorized into the following:"
            typesJson={serviceTypesData["Sexual Offences"]}
          />
          <ServiceDescriptionSection
            header="Consent and the Law"
            content={
              <div>
                <div>Consent is a critical factor in many sexual offences. In Victoria, a person cannot legally give consent if:</div>
                <ul>
                  <li>They are under the age of 16.</li>
                  <li>They are under the age of 18 and the accused is in a position of authority over them (e.g., teacher, coach).</li>
                  <li>They are intoxicated, unconscious, or otherwise unable to make informed decisions.</li>
                  <li>They are coerced, threatened, or manipulated into the act.</li>
                </ul>
                <div>The law assumes that consent is ongoing and can be withdrawn at any time. Engaging in sexual activity after consent has been withdrawn is illegal.</div>
              </div>
            }
          />
          <ServiceDescriptionSection
            header="Penalties for Sexual Offences"
            content={
              <div>
                <div>The penalties for sexual offences in Victoria are severe and can include:</div>
                <ul>
                  <li>Long-term imprisonment: For crimes like rape, child sexual abuse, or serious sexual assaults, offenders can face sentences of up to 25 years or more.</li>
                  <li>Placement on the Sex Offenders Register: Individuals convicted of certain sexual offences may be required to register as a sex offender, which involves regular reporting to police, restrictions on where they can live and work, and other long-term legal obligations.</li>
                  <li>Fines and Compensation: In addition to prison time, offenders may be required to pay compensation to victims for physical or emotional harm.</li>
                </ul>
              </div>
            }
          />
          <ServiceLegalRepresentationRationale
            header="Why Legal Representation is Crucial"
            content="Being charged with a sexual offence can have lifelong consequences, including imprisonment, reputational damage, and the potential to be listed on the sex offender register. Given the seriousness of these charges, it is vital to have experienced legal representation to navigate the complexities of the case, ensure a fair trial, and provide the best possible defence."
          />
          <ServiceContactUsSection
            header="Contact Us for Legal Assistance"
            content="If you or someone you know is facing charges related to sexual offences, it is crucial to seek legal advice immediately. Our expert legal team is here to provide confidential, non-judgmental support and representation to help you navigate the legal process."
          />
        </div>
      </div>
    </div>
  );
};

export default SexualOffences;